/**
 * Stripe Error Handler
 * Handles common Stripe errors, especially those caused by ad blockers
 */

export const isStripeBlockedError = (error: any): boolean => {
  if (!error) return false;

  const errorMessage = error.message?.toLowerCase() || '';
  const errorName = error.name?.toLowerCase() || '';

  return (
    errorMessage.includes('fetch') ||
    errorMessage.includes('blocked') ||
    errorMessage.includes('errBlockedByClient') ||
    errorMessage.includes('failed to fetch') ||
    errorName === 'fetcherror' ||
    error.code === 'ERR_BLOCKED_BY_CLIENT'
  );
};

export const getStripeErrorMessage = (error: any): string => {
  if (isStripeBlockedError(error)) {
    return 'Payment service blocked by ad blocker. Please disable your ad blocker and try again, or try a different browser.';
  }

  return error.message || 'An unexpected error occurred with the payment service.';
};

// Global error handler for Stripe analytics errors
export const setupStripeErrorHandler = () => {
  const stripeRejectionKey = '__drxStripeUnhandledRejectionInstalled__';
  const stripeErrorKey = '__drxStripeGlobalErrorInstalled__';

  // Capture unhandled promise rejections from Stripe analytics
  if (!(window as unknown as Record<string, boolean>)[stripeRejectionKey]) {
    (window as unknown as Record<string, boolean>)[stripeRejectionKey] = true;
    window.addEventListener('unhandledrejection', (event) => {
      const error = event.reason;

      if (isStripeBlockedError(error)) {
        event.preventDefault();
        console.info('Stripe analytics blocked by ad blocker (this is normal and does not affect payments)');
      }
    });
  }

  // Capture general errors
  if (!(window as unknown as Record<string, boolean>)[stripeErrorKey]) {
    (window as unknown as Record<string, boolean>)[stripeErrorKey] = true;
    window.addEventListener('error', (event) => {
      const error = event.error;

      if (isStripeBlockedError(error)) {
        event.preventDefault();
        console.info('Stripe analytics blocked by ad blocker (this is normal and does not affect payments)');
      }
    });
  }
};
